<div class="d-flex px-md-5 px-2 justify-content-center sc-overview">
  <div class="col-lg-11">

    <div class="row g-4">

      <!-- Profile card -->
      <div class="col-lg-4">
        <div class="dash-panel sc-profile-card text-center">
          <div class="profile-pic">
            <a [routerLink]="" class="sc-avatar-edit" data-bs-toggle="modal" data-bs-target="#avatarModal" style="cursor:pointer" aria-label="Change avatar">
              <img loading="lazy" [src]="'assets/Characters/' + user.icon_index + '.webp'" alt="avatar" class="rounded-circle img-fluid sc-profile-avatar" style="width: 150px;" draggable="false">
              <span class="sc-avatar-gear"><i class="fa-solid fa-gear"></i></span>
            </a>
          </div>
          <h2 class="sc-profile-name">{{user.username}}</h2>
          <p class="sc-profile-meta">Last login · {{user.last_login | date :'short'}}</p>
          <p class="sc-profile-meta">Joined · {{user.date_joined | date :'short'}}</p>

          <div class="sc-steam-area">
            <i class="fab fa-steam fa-lg" style="color: var(--sc-muted)"></i>
            @if (!user.is_steam_account_linked) {
              <a [routerLink]="" (click)="LoginSteam()" class="sc-steam-link">
                <i class="fas fa-link"></i> Link Steam
              </a>
            }
            @if (user.is_steam_account_linked) {
              <span class="sc-steam-linked">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
                </svg>
                Steam Account linked
              </span>
            }
          </div>
        </div>
      </div>

      <!-- Details + completion -->
      <div class="col-lg-8">

        <div class="dash-panel">
          <h3 class="dash-section-title">Profile</h3>
          <div class="dash-row">
            <p class="dash-label">Full Name</p>
            @if (user.first_name) {
              <p class="dash-value">{{user.first_name}} {{user.last_name}}</p>
            }
            @if (!user.first_name) {
              <p class="dash-value sc-warn">Not set</p>
            }
          </div>
          <div class="dash-row">
            <p class="dash-label">Email</p>
            @if (user.email) {
              <p class="dash-value">{{user.email}}</p>
            }
            @if (!user.email) {
              <p class="dash-value sc-warn">Not set</p>
            }
          </div>
        </div>

        <div class="dash-panel mt-4">
          <h3 class="dash-section-title">Account Completion</h3>
          <div class="row align-items-center g-3">
            <div class="col-sm-4 text-center">
              <circle-progress [percent]="progressPRC"></circle-progress>
            </div>
            <div class="col-sm-8">
              @if (progressPRC === 100) {
                <p class="sc-allgood">Your account is in optimal condition</p>
              }

              <div class="dash-tile-grid">
                <div class="dash-tile" [ngClass]="this.user.first_name ? 'is-ok' : 'is-warn'">
                  <span class="dash-tile-icon">
                    @if (this.user.first_name) {
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" viewBox="0 0 16 16"><path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z"/><path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z"/></svg>
                    }
                    @if (!this.user.first_name) {
                      <i class="fa-solid fa-triangle-exclamation"></i>
                    }
                  </span>
                  <span>
                    <p class="dash-tile-label">Account Owner</p>
                    <p class="dash-tile-state">{{ this.user.first_name ? 'Set' : 'Update needed' }}</p>
                  </span>
                </div>

                <div class="dash-tile" [ngClass]="this.user.has_password ? 'is-ok' : 'is-warn'">
                  <span class="dash-tile-icon">
                    @if (this.user.has_password) {
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" viewBox="0 0 16 16"><path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z"/><path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z"/></svg>
                    }
                    @if (!this.user.has_password) {
                      <i class="fa-solid fa-triangle-exclamation"></i>
                    }
                  </span>
                  <span>
                    <p class="dash-tile-label">Password</p>
                    <p class="dash-tile-state">{{ this.user.has_password ? 'Secured' : 'Set a password' }}</p>
                  </span>
                </div>

                <div class="dash-tile" [ngClass]="this.user.email ? 'is-ok' : 'is-warn'">
                  <span class="dash-tile-icon">
                    @if (this.user.email) {
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" viewBox="0 0 16 16"><path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z"/><path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z"/></svg>
                    }
                    @if (!this.user.email) {
                      <i class="fa-solid fa-triangle-exclamation"></i>
                    }
                  </span>
                  <span>
                    <p class="dash-tile-label">Email Address</p>
                    <p class="dash-tile-state">{{ this.user.email ? 'Set' : 'Add an email' }}</p>
                  </span>
                </div>

                <div class="dash-tile" [ngClass]="(user.has_verified_email && user.email) ? 'is-ok' : 'is-warn'">
                  <span class="dash-tile-icon">
                    @if (user.has_verified_email && user.email) {
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" viewBox="0 0 16 16"><path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z"/><path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z"/></svg>
                    }
                    @if (!(user.has_verified_email && user.email)) {
                      <i class="fa-solid fa-triangle-exclamation"></i>
                    }
                  </span>
                  <span>
                    <p class="dash-tile-label">Email Verified</p>
                    <p class="dash-tile-state">{{ (user.has_verified_email && user.email) ? 'Confirmed' : 'Pending' }}</p>
                  </span>
                </div>

                <div class="dash-tile" [ngClass]="(this.user.has_subscribed_to_newsletter && this.user.email) ? 'is-ok' : 'is-warn'">
                  <span class="dash-tile-icon">
                    @if (this.user.has_subscribed_to_newsletter && this.user.email) {
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" viewBox="0 0 16 16"><path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z"/><path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z"/></svg>
                    }
                    @if (!(this.user.has_subscribed_to_newsletter && this.user.email)) {
                      <i class="fa-solid fa-triangle-exclamation"></i>
                    }
                  </span>
                  <span>
                    <p class="dash-tile-label">Newsletter</p>
                    <p class="dash-tile-state">{{ (this.user.has_subscribed_to_newsletter && this.user.email) ? 'Subscribed' : 'Subscribe' }}</p>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</div>
